import { RouteConfig } from 'vue-router'

export const PROJECT_LIST_PATH = '/project-list'
export const PROJECT_LIST_NAME = 'ProjectListView'

export const projectListRoutesConfig: RouteConfig[] = [
  {
    path: PROJECT_LIST_PATH,
    name: PROJECT_LIST_NAME,
    component: () => import('@/features/projectList/views/ProjectList.vue')
  }
]
